<template>
<div style="margin: 10%">
  <el-skeleton :rows="6" animated />
</div>
</template>

<script>
export default {
  name: "Resultdownload"
}
</script>

<style scoped>

</style>